import { ChangeDetectionStrategy, Component, inject, input, OnInit, signal } from '@angular/core';
import { SplashAnimationType } from './splash-animation-type';
import { DeviceDetectorService } from 'ngx-device-detector';
import { CommonModule } from '@angular/common';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  selector: 'app-splash',
  templateUrl: './splash.component.html',
  imports: [CommonModule]
})
export class SplashComponent implements OnInit {
  private readonly deviceDetector = inject(DeviceDetectorService);
  
  windowWidth = signal<string>('');
  splashTransition = signal<string>('');
  opacityChange = signal<number>(1);
  showSplash = signal<boolean>(false);

  animationDuration = input<number>(0.5);
  duration = input<number>(3);
  animationType = input<SplashAnimationType>(SplashAnimationType.SlideLeft);

  ngOnInit(): void {
    if (!this.deviceDetector.isMobile() && !this.deviceDetector.isTablet()) {
      return;
    }

    this.showSplash.set(!this.showSplash());
    setTimeout(() => {
      let transitionStyle = '';
      switch (this.animationType()) {
        case SplashAnimationType.SlideLeft:
          this.windowWidth.set('-' + window.innerWidth + 'px');
          transitionStyle = 'left ' + this.animationDuration + 's';
          break;
        case SplashAnimationType.SlideRight:
          this.windowWidth.set(window.innerWidth + 'px');
          transitionStyle = 'left ' + this.animationDuration + 's';
          break;
        case SplashAnimationType.FadeOut:
          transitionStyle = 'opacity ' + this.animationDuration + 's';
          this.opacityChange.set(0);
      }

      this.splashTransition.set(transitionStyle);

      setTimeout(() => {
        this.showSplash.set(!this.showSplash());
      }, this.animationDuration() * 1000);
    }, this.duration() * 1000);
  }
}
